import React from "react";

import { useInView } from "react-intersection-observer";

import businessImageOne from "../../assets/images/business-image-one.png";
import businessImageTwo from "../../assets/images/business-image-two.png";
import multiLayerInfinite from "../../assets/images/multi-layer-infinite.png";

import cs from "classnames";

import RegisterBanner from "../../components/RegisterBanner/RegisterBanner";

import "./Business.scss";

const Business = () => {
  const { ref: businessTitleRef, inView: businessTitleVisibility } =
    useInView();
  const { ref: businessFirstImageRef, inView: businessFirstImageVisibility } =
    useInView();
  const { ref: businessSecondImageRef, inView: businessSecondImageVisibility } =
    useInView();
  const { ref: businessThirdImageRef, inView: businessThirdImageVisibility } =
    useInView();
  const { ref: becomeTitleRef, inView: becomeTitleVisibility } = useInView();
  const { ref: becomeDescriptionRef, inView: becomeDescriptionVisibility } =
    useInView();

  return (
    <div className="Business">
      <div className="Business__container">
        <div
          ref={businessTitleRef}
          className={cs(
            "Business__title",
            businessTitleVisibility && "Business__title-animation",
          )}
        >
          Infinite for <span>Businesses</span>{" "}
        </div>

        <div className="Business__images">
          <div className="Business__image-group">
            <div
              ref={businessFirstImageRef}
              className={cs(
                "Business__image-container",
                businessFirstImageVisibility &&
                  "Business__image-container-imageOneAnimation",
              )}
            >
              <img
                loading="lazy"
                className="Business__image"
                src={businessImageOne}
              />
              <div className="Business__image-text">
                Unmatched Performance expect our products to deliver seamless
                connectivity, regardless of demand.
              </div>
            </div>{" "}
            <div
              ref={businessSecondImageRef}
              className={cs(
                "Business__image-container",
                "Business__image-container-infinite",
                businessSecondImageVisibility &&
                  "Business__image-container-imageTwoAnimation",
              )}
            >
              <img
                loading="lazy"
                className={cs("Business__image", "Business__image-infinite")}
                src={multiLayerInfinite}
              />
              <div
                className={cs(
                  "Business__image-text",
                  "Business__image-text-infinite",
                )}
              >
                <span>Dedicated Support</span> count on our committed team to
                ensure flawless operations and comprehensive assistance.
              </div>
            </div>{" "}
          </div>
          <div
            ref={businessThirdImageRef}
            className={cs(
              "Business__image-container",
              businessThirdImageVisibility &&
                "Business__image-container-imageThreeAnimation",
            )}
          >
            <img
              loading="lazy"
              className="Business__image"
              src={businessImageTwo}
            />
            <div
              className={cs("Business__image-text", "Business__image-text-two")}
            >
              Efficiency without Compromise With Infinite, enjoy swift delivery
              and competitive pricing without sacrificing quality.
            </div>
          </div>
        </div>

        <div className="Business__become">
          <div
            ref={becomeTitleRef}
            className={cs(
              "Business__become-title",
              becomeTitleVisibility && "Business__become-title-animation",
            )}
          >
            Unlocking Boundless Potential with Infinite for Business
          </div>
          <div
            ref={becomeDescriptionRef}
            className={cs(
              "Business__become-description",
              becomeDescriptionVisibility &&
                "Business__become-description-animation",
            )}
          >
            <div className="Business__become-section">
              Infinite isn't just another B2B 5G and Wi-Fi 6 company – we're
              your strategic partner for exceptional results.
            </div>

            <div className="Business__become-section">
              With Infinite, telecom leaders access groundbreaking solutions
              redefining connectivity.
            </div>

            <div className="Business__become-section">
              Our core principles – Performance, Support, Speed, and Cost –
              define us. Here's why Infinite is your savvy choice:
            </div>

            <div className="Business__become-section">
              Unmatched Performance - Crafted for seamless connectivity, our
              products ensure your customers enjoy flawless experiences.
            </div>

            <div className="Business__become-section">
              Dedicated Support - Count on our devoted team for comprehensive
              assistance, ensuring flawless operations.
            </div>

            <div className="Business__become-section">
              Efficiency & Value - Expect expedited delivery and competitive
              pricing without compromising quality, maximizing your investment.
            </div>

            <div className="Business__become-section">
              Partnering with Infinite unlocks limitless potential for your
              enterprise. Join us in shaping the future of connectivity and
              delivering unparalleled experiences to your customers.
            </div>
          </div>
        </div>

        <div className="Business__register">
          <RegisterBanner />
        </div>
      </div>
    </div>
  );
};

export default Business;
